import { vec3, quat } from 'gl-matrix';

WL.registerComponent('player-body', {
    playerHead: {type: WL.Type.Object},
    yOffset: {type: WL.Type.Float},
}, {
    init: function() {
        this.fromVector = vec3.create();
        this.toVector = vec3.create();

        this.mag = 0;
        this.q = quat.create();
    },
    update: function(dt) {
        // https://stackoverflow.com/questions/5782658/extracting-yaw-from-a-quaternion
        quat.set(this.q, 0, this.playerHead.rotationWorld[1], 0, this.playerHead.rotationWorld[3]);
        this.mag = Math.sqrt((this.q[1] ** 2) + (this.q[3] ** 2));
        quat.set(this.q, 0, this.q[1] / this.mag, 0, this.q[3] / this.mag);
        quat.copy(this.object.rotationWorld, this.q);

        this.playerHead.getTranslationWorld(this.toVector);
        this.toVector[1] = this.toVector[1] + this.yOffset;
        this.object.setTranslationWorld(this.toVector);
    },
});
